export class TransportError extends Error {
  constructor(message?: string) {
    super(message || 'Transport error');
    this.name = 'TransportError';
  }
}

export class DisconnectedError extends TransportError {
  closeEvent?: CloseEvent;
  closeCode?: number;
  description?: string;

  constructor(cause?: string, extra?: { context: CloseEvent; description?: string }) {
    super();

    this.name = 'DisconnectedError';
    this.cause = cause;
    this.closeEvent = extra?.context;
    this.closeCode = extra?.context?.code;
    this.description = extra?.description;
    this.message = `Websocket disconnected!${this.cause ? ` Cause: ${this.cause}` : ''} ${this.closeCode ? ` Close code: ${this.closeCode}` : ''}`;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, DisconnectedError);
    }
  }
}

export class NoDocumentProvided extends TransportError {
  constructor() {
    super('No document identification provided');
    this.name = 'NoDocumentProvided';
  }
}

export class ConnectionError extends TransportError {
  original: any;
  constructor(original: any) {
    super();
    this.name = 'ConnectionError';
    this.message = 'Websocket failed to connect!';
    this.original = original;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ConnectionError);
    }
  }

  get code() {
    return this.original?.data?.code || 500;
  }

  get type() {
    return this.original?.data?.type || 'Gerbil';
  }
}

export class TimeoutError extends TransportError {
  original: any;
  code: any;
  constructor(original: any) {
    super();
    this.name = 'TimeoutError';
    this.message = 'Websocket connection timed out!';
    this.code = 4;
    this.original = original;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, TimeoutError);
    }
  }
}

export class UnknownError extends TransportError {
  original: any;
  code: any;
  reason: any;
  constructor(original: any, reason?: any) {
    super();
    this.name = 'UnknownError';
    this.code = 5;
    this.reason = reason;
    this.original = original;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, UnknownError);
    }
  }
}
